import "./08_contact_component.css"

import { useState } from "react";
import axios from 'axios';

import instagram from "../../../assets/Images/Elements/Instagram.svg"
import LinkedIn from "../../../assets/Images/Elements/LinkedIn.svg"

export default function Contact() {
    const [fname, setFname] = useState('');
    const [fphone, setFphone] = useState('');
    const [fmessage, setFmessage] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        const formData = new FormData();
        formData.append("name", fname);
        formData.append("phone", fphone);
        formData.append("message", fmessage);
        
        try {
            const res = await axios.post("https://adstrate.in/contact.php", formData, {
            headers: { "Content-Type": "multipart/form-data" },
            });
            alert("Alert: " + res.data.message);
        } catch (err) {
            alert("Failed: " + (err.response?.data?.error || "Unknown error"));
        }
    }; 
    return (
        <div className="Contact-MainSection">
            <div className="Contact-MainSection-Details">
                <div className="Contact-MainSection-Details-Info">
                    <h1>Contact Us</h1>
                    <p>
                        Looking for a results-driven digital marketing agency in Mumbai? At Adstrate, we offer social media marketing, content creation, and Instagram marketing services, combining creative strategies with data-driven insights to boost your brand’s online presence and drive growth. We handle your digital marketing so you can focus on growing your business.
                    </p>
                </div>
                <div className="Contact-ContactSection-Main">
                        <div className="Contact-ContactSection-Details">
                            <div className="Contact-ContactSection-Details-Info">
                                <p className="LinkLabel">Phone No:</p>
                                <a href="tel:+918976050818">+91 8976 050 818</a>
                            </div>
                            <div className="Contact-ContactSection-Details-Info">
                                <p className="LinkLabel">Phone No:</p>
                                <a href="tel:+917666814040">+91 76668 14040</a>
                            </div>
                            <div className="Contact-ContactSection-Details-Info">
                                <p className="LinkLabel">Email: </p>
                                <a href="mailto:contact@adstrate.in">contact@adstrate.in</a>
                            </div>
                        </div>
                        <div className="Contact-ContactSection-Socials">
                            <p className="LinkLabel">Follow Us</p>
                            <div className="Contact-ContactSection-Socials-Icons">
                                <a href="https://www.instagram.com/adstrate_in/"><img src={instagram} alt="" /></a>
                                <a href="https://www.linkedin.com/in/adstrate-agency/"><img src={LinkedIn} alt="" /></a>
                            </div>
                        </div>
                    </div>
            </div>
            <form onSubmit={handleSubmit} className="Contact-FormSection-Form">
                <div className="Contact-FormSection-Form-Flex">
                    <div className="Contact-FormSection-Form-Input">
                        <label for="fname">Name</label>
                        <input type="text" name="fname" placeholder="Name" value={fname} onChange={(e) => setFname(e.target.value)}  required/>
                    </div>
                    <div className="Contact-FormSection-Form-Input">
                        <label for="fphone">Phone No</label>
                        <input type="text" name="fphone" placeholder="Phone No" value={fphone} onChange={(e) => setFphone(e.target.value)} required/>
                    </div>
                </div>
                    <div className="Contact-FormSection-Form-Input">
                        <label for="fmessage">Message</label>
                        <textarea rows="6" name="fmessage" placeholder='Write something...' onChange={(e) => setFmessage(e.target.value)} required/>
                    </div>
                    <button>Contact Us</button>
            </form>    
        </div>
    );
}